import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, NavLink } from "react-router-dom";
import AttendanceNavCard from "./AttendanceNavCard";
import { navData } from "./Data/NavData";
import { useTranslation } from "react-i18next";
import { PERMISSIONS } from "../../../../config/permission";
import ProtectedAction from "../../../../Routes/ProtectedRoutes/ProtectedAction";
import { fetchStaffAttendanceStats } from "../../../../Store/Slices/Admin/staffAttendance/staffAttendance.thunk";

const NavSection = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("admClass");

  const attendanceStat = useSelector(
    (state) => state.admin.staffAttendance.stats || {},
  );

  // Mapping the correct stat keys to navData
  const dataMapping = {
    "Total Staff": "totalStaffs",
    "Present Today": "present",
    "Absent Today": "absent",
    "Leave Today": "leave",
  };

  // Directly map `navData` and use `attendanceStat` values.
  const mappedData = navData?.map((item) => ({
    ...item,
    value: attendanceStat[dataMapping[item.label.trim()]] || 0, // Map values from the attendanceStat object
    label: t(item.label.trim()), // Translate labels using i18n
  }));

  useEffect(() => {
    dispatch(fetchStaffAttendanceStats());
  }, [dispatch]);

  return (
    <div>
      <div className="flex items-center justify-between mb-6 bg-white rounded-xl shadow-sm p-4">
        <div>
          <h2 className="page-heading">{t("Staff Attendance")}</h2>
          <p className="subheading">
            {t("Track and manage staff attendance records efficiently.")}
          </p>
        </div>
        <ProtectedAction requiredPermission={PERMISSIONS.MARK_ATTENDANCE}>
          <NavLink
            to={`/staff/take_attendance`}
            className="btn-gradient px-4 py-2"
          >
            {t("Take Attendance")}
          </NavLink>
        </ProtectedAction>
      </div>
      <div className="flex space-x-4 mb-4">
        {mappedData?.map((item) => (
          <AttendanceNavCard
            key={item.label}
            label={item.label}
            value={item.value}
            bgColor={item.bgColor}
            icon={item.icon}
            iconBackground={item.iconColor}
            textColor={item.textColor}
          />
        ))}
      </div>
    </div>
  );
};

export default NavSection;
